import { render, staticRenderFns } from "./ConversionInsightCard.vue?vue&type=template&id=5cb4fee0&scoped=true"
import script from "./ConversionInsightCard.vue?vue&type=script&lang=js"
export * from "./ConversionInsightCard.vue?vue&type=script&lang=js"
import style0 from "./ConversionInsightCard.vue?vue&type=style&index=0&id=5cb4fee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb4fee0",
  null
  
)

export default component.exports